import React from 'react';
import { Link, Typography } from '@hpstellar/core';

import withWindowResize from '../../ui/components/window-resize';

import './css/dlp.less';

class DLPHeader extends React.Component {
    state = {
        learnMoreClicked: false,
        mounted: false,
    };

    componentDidMount() {
        this.setState({ mounted: true }); // show learn more only after hydration
    }

    getCopyBlock = () => {
        let { device } = this.props;
        let copyBlock;
        if (device !== 'desktop') {
            document.querySelectorAll('#disclaimerTabs [id^="wordCloud"]').forEach(node => {
                if (
                    node &&
                    typeof node.textContent === 'string' &&
                    /more about these products/i.test(node.textContent.trim())
                ) {
                    copyBlock = node;
                }
            });
        } else {
            copyBlock = document.querySelector('.more-about-products');
        }

        return copyBlock;
    };

    waitForCopyBlockAndOpen = open => {
        let copyBlockContainer = document.querySelector('.dlp-footer');
        copyBlockContainer.scrollIntoView({ behavior: 'smooth' });
        let waitAttempts = 0;
        let waitForMoreAboutProducts = setInterval(() => {
            let copyBlock = this.getCopyBlock();
            if (copyBlock) {
                open(copyBlock);
                clearInterval(waitForMoreAboutProducts);
            }

            if (++waitAttempts > 5) {
                clearInterval(waitForMoreAboutProducts);
            }
        }, 500);
    };

    isCopyBlockClosed = copyBlock => {
        if (!copyBlock) {
            return false;
        }
        let { device } = this.props;

        return device !== 'desktop'
            ? copyBlock.closest('[id^=wordCloud][aria-expanded="false"]') ||
                  copyBlock.closest('[id^=wordCloud][aria-selected="false"]')
            : /(^|[ ])+inactive/.test(copyBlock.className);
    };

    handleLearnMoreClick(e) {
        e.preventDefault();
        let { device } = this.props;
        const { learnMoreClicked } = this.state;
        let copyBlock = this.getCopyBlock();

        const open = queriedCopyBlock => {
            /*if learnMoreClicked state is initially false, or if the 'inactive' class is on the copyBlock element,
              open the copy block. Otherwise, don't click on the copy block button (since it would trigger closing the copy block)
              but instead, just scroll to it.
            */
            let copyBlockElem = queriedCopyBlock || copyBlock;
            if (learnMoreClicked === false || this.isCopyBlockClosed(copyBlockElem)) {
                copyBlockElem.click();
                this.setState({ learnMoreClicked: true });
            }
            if (device === 'desktop') {
                return copyBlockElem && copyBlockElem.scrollIntoView({ behavior: 'smooth' });
            }
            // mobile scroll
            document.querySelector('#disclaimerTabs').scrollIntoView({ behavior: 'smooth' });
        };

        if (copyBlock) {
            return open();
        }

        this.waitForCopyBlockAndOpen(open);
    }

    contentRendered = () => {
        const { seoParagraph } = this.props;
        if (seoParagraph) {
            let seoParagraphObj;
            try {
                seoParagraphObj = JSON.parse(seoParagraph);
            } catch (e) {
                seoParagraphObj = {};
            }
            //Check if there's content
            const { blocks = [] } = seoParagraphObj || {};
            //If there's only one line && that line is empty
            if (blocks.length === 1 && blocks[0].text.trim() === '') {
                return false;
            }

            return true;
        }

        return false;
    };

    renderHeaderDetails() {
        const { keyword, hideSeoParagraph = false, intelBanner } = this.props;
        const { mounted } = this.state;
        const gtmProps = {
            'data-gtm-category': 'linkClick',
            'data-gtm-id': 'product',
            'data-gtm-value': 'learn-more',
        };

        return (
            <div className={`dlp-header${intelBanner ? ' with-intel-banner' : ''}`}>
                <Typography variant={'titleM'} tag={'h1'} isCaps>
                    {keyword}
                </Typography>
                {mounted && this.contentRendered() && !hideSeoParagraph && (
                    <div className="dlp-learn-more">
                        <Link tag="div" onClick={e => this.handleLearnMoreClick(e)} {...gtmProps}>
                            {' '}
                            Learn more
                        </Link>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { keyword, hideSeoParagraph = false } = this.props;
        return keyword && <div className="dlp-header-container">{this.renderHeaderDetails()}</div>;
    }
}

export default withWindowResize(DLPHeader);
